import { Modal } from 'rsuite';
import WdLoading from "../../assets/WDAdvantageLoading.gif";

const CustomLoader=({open}:{open:boolean})=>{
  return (
    <div>
        <Modal className="custom-loader" backdrop="static" open={open} size="xs">
            <Modal.Body>
                <div className="flex item-center justify-center">
                    <img className="h-full w-[60%]" src={WdLoading} alt="Loading..." />
                </div>
            </Modal.Body>
        </Modal>
    </div>
  )
}

export default CustomLoader;
